var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBrl = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.999 4.96265L21.912 12.267L11.999 19.5713L2.08594 12.267L11.999 4.96265Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 16.4393C14.3052 16.4393 16.174 14.5706 16.174 12.2654C16.174 9.96027 14.3052 8.09155 12.0001 8.09155C9.69489 8.09155 7.82617 9.96027 7.82617 12.2654C7.82617 14.5706 9.69489 16.4393 12.0001 16.4393Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91373 12.0095C9.18792 12.0095 8.48747 12.1199 7.82812 12.3248C7.85733 14.6048 9.71376 16.4443 12.0007 16.4443C13.4148 16.4443 14.6638 15.7404 15.4188 14.6646C14.127 13.0475 12.1395 12.0095 9.91373 12.0095Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0981 13.069C16.1484 12.8101 16.1755 12.543 16.1755 12.2694C16.1755 9.96413 14.3068 8.09546 12.0016 8.09546C10.2816 8.09546 8.80502 9.13613 8.16602 10.622C8.73086 10.5049 9.31567 10.4433 9.91469 10.4433C12.3389 10.4432 14.532 11.451 16.0981 13.069Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBrl);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BRL.b5fe1dc8301bfa4240fa6b764e28a7d2.svg";